module.exports = __webpack_public_path__ + "img/New PACI Flow - Enable Authentication - 6.d7788429.png";